<script lang="ts">
    import { onMount } from "svelte";
    let showBanner : boolean = false;

    onMount(async () => {
       try {
            const response = await fetch(`${import.meta.env.VITE_BANNER_ENDPOINT}`);
            const data = await response.json()
            showBanner = data.show_cookie_banner
       }catch (error) {
            showBanner = true;
            console.log(error)
       }
    })

    const hideBanner = async () => {
        showBanner = false
        const response = await fetch(`${import.meta.env.VITE_BANNER_ENDPOINT}?accepted=true`)
        const data = await response.json()
    }

</script>

{#if false}
    <div class="banner">
        <div class="banner__container">
            <p>
                OfferZen uses cookies to improve your experience, and for measurement and analytics purposes.
                By using our website and our services, you agree to our use of cookies as described in our
                <a href="https://www.offerzen.com/cookie-declaration" data-sveltekit-reload>Cookie Declaration.</a>
            </p>
            <button on:click={() => hideBanner()}>Accept</button>
        </div>
    </div>
{/if}

<style lang="postcss">
@import '../../styles/_mixins.css';

.banner {
    padding:18px;
    width:100%;
    position: fixed;
    bottom:0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--color_offerzen_lightblue);
    z-index:990;

    @mixin screen-lg {
        padding:18px 80px;
    }

    @mixin screen-md {
        padding:18px 60px;
    }

    @mixin screen-sm {
        padding:18px 24px;
    }

    & .banner__container {
        display:flex;
        align-items: center;
        justify-content: center;
        gap:20px;
        & p {
            color: #343951;
            font-size:16px;
            line-height:140%;
            margin:0;

            & a {
                color: #343951
            }
        }

       @mixin screen-md {
            width:100%;
       }

        @mixin screen-sm {
            flex-direction:column;
        }

        & button {
            display: inline-block;
            padding: 9px 15px;
            color: var(--color_white);
            border: 0;
            line-height: inherit;
            text-decoration: none;
            cursor: pointer;
            border-radius: 4px;
            background-color: #5ea5ee;
            box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
            -webkit-transition: background-color 2.3s;
            transition: background-color 2.3s;
            height:40px;

            &:hover{
                background-color: #5698dc;
            }

            @mixin screen-sm {
                height:48px;
                width:100%;
            }
        }
    }
}
</style>